/**
 * Returns the array index of a correlation.
 *
 * @param {Values} correlations
 * @param {Correlation} correlation
 */
export function getCorrelationIndex(correlations, correlation) {
    return correlations.findIndex((_correlation) => _correlation.id === correlation.id);
}
//# sourceMappingURL=getCorrelationIndex.js.map